module.exports = __webpack_public_path__ + "static/media/noresultfound.60a2fd39.png";